import Vue from 'vue'
import ToggleButton from 'vue-js-toggle-button'
import LaddaButton from 'codium-ladda-button'
import NoResults from 'components/misc/NoResults'
import PickstarLoading from 'components/misc/PickstarLoading'

Vue.use(ToggleButton)
Vue.component('ladda-button', LaddaButton)
Vue.component('no-results', NoResults)
Vue.component('pickstar-loading', PickstarLoading)
